export default {
  header: 'Esta semana',
  metrics: {
    points: 'Pontos',
    visits: 'Visitas',
    in_store_sign_ups: 'Registos na Loja',
    rewards_redeemed: 'Recompensas Utilizadas',
  },
};
